import loadScript from '../util/loader';

const defaultOptions = {
  cc_load_policy: 1,
  iv_load_policy: 3,
  modestbranding: 1,
  playsinline: 1,
  controls: 1,
  showinfo: 0,
  ecver: 2,
  fs: 1,
  rel: 0,
};

const selectors = {
  player: 'iframe, [data-replace]',
  videoId: 'data-video-id',
};

export default function embedYoutube(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
  const playerElement = playerWrapper.querySelector(selectors.player);
  const youtubeKey = playerWrapper.querySelector(`[${selectors.videoId}]`).getAttribute(selectors.videoId);
  loadScript({url: 'https://www.youtube.com/iframe_api'});
  const playerPromise = window.youtubeLoaderPromise
    .then(() => {
      let player = new window.YT.Player(playerElement, {
        videoId: youtubeKey,
        playerVars: {
          ...playerOptions,
        },
        events: {
          onStateChange: (event) => {
            // We need these play/pause events because the YouTube video does not emit the regular play/pause events on Mobile
            if (event.data == 1) {
              playerWrapper.dispatchEvent(new CustomEvent('play'));
            } else if (event.data == 2) {
              playerWrapper.dispatchEvent(new CustomEvent('pause'));
            }
          },
        },
      });
      playerWrapper.addEventListener('pause', () => {
        try {
          player.pauseVideo();
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('play', () => {
        try {
          if (player.playVideo) {
            player.playVideo();
          } else {
            player.addEventListener('onReady', () => {
              player.playVideo();
            });
          }
        } catch (e) {
          console.warn(e);
        }
      });
      playerWrapper.addEventListener('destroy', () => {
        try {
          if (player.destroy) {
            player.destroy();
          }
        } catch (e) {
          console.warn(e);
        }
      });
      return player;
    })
    .catch((err) => {
      console.error(err);
    });
  return playerPromise;
}

window.youtubeLoaderPromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = function () {
    resolve();
  };
});
